import { setCookie } from "cookies-next";

export const saveToLocalStorage = (key: string, value: any): void => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (err) {
    console.log(`Error saving to localStorage for key: ${key}`, err);
  }
};

export const getFromLocalStorage = (key: string): any => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (err) {
    console.log(`Error reading from localStorage for key: ${key}`, err);
    return null;
  }
};

export const removeFromLocalStorage = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.log(`Error removing from localStorage for key: ${key}`, err);
  }
};

export const setStoreCookies = (storeId: string | number, storeRegion: string | number ) => {
  let store =`${storeId}_${storeRegion}`;
  setCookie('storeId', store, {
    secure: true,
    path: '/', // required
    maxAge: 60 * 60 * 24 * 7, // 7 days
  });
}

export const appendStoreIdToItems = (items: Record<string, any>, storeID: string | number) => {
  try {
   const result = items?.map((item: { item_id: string; }) => ({
      ...item,
      item_id: `${item.item_id}_${storeID}`
    }));
    return result
  } catch {
    return [];
  }
};

